module.exports = __webpack_public_path__ + "img/bot_intent_rg_ac.352e24f3.svg";